<!-- <template>
  <div class="dealer-types-container">
    <transition name="toast">
      <div v-if="notification.show" class="toast-notification" :class="notification.type">
        <v-icon size="20" color="white">{{ notification.icon }}</v-icon>
        <div class="toast-content">
          <span class="toast-title">{{ notification.title }}</span>
          <span class="toast-msg">{{ notification.message }}</span>
        </div>
      </div>
    </transition>

    <div class="header-section">
      <div class="title-area">
        <h2>CREATE & VIEW DEALER TYPES</h2>
        <p>Establish & access a new dealer types tailored to your needs.</p>
      </div>
      <button class="btn-back" @click="goBack">
        <v-icon size="18" color="#404a5f">mdi-chevron-left</v-icon> BACK
      </button>
    </div>

    <div class="main-card">
      <div class="card-header-row">
        <span class="card-title">DEALER TYPE LIST</span>
        <div class="action-header-btns">
          <button class="btn-create-outline" @click="openCreateModal">CREATE NEW DEALER TYPE</button>
          <button class="export-btn pdf" @click="exportToPDF">
            <v-icon size="18" class="mr-1">mdi-file-pdf-box</v-icon> PDF
          </button>
          <button class="export-btn excel" @click="exportToExcel">
            <v-icon size="18" class="mr-1">mdi-file-excel-box</v-icon> Excel
          </button>
        </div>
      </div>

      <div class="search-stats-container">
        <div class="stats-box">
          <div class="stats-number">{{ filteredDealerTypes.length }}</div>
          <div class="stats-text">NUMBER OF TYPES</div>
        </div>
        <div class="search-box-wrapper">
          <div class="search-fieldset">
            <label>Search</label>
            <input v-model="searchQuery" type="text" placeholder="Search" />
          </div>
        </div>
      </div>

      <div class="table-container">
        <table class="dealer-table">
          <thead>
            <tr>
              <th style="width: 35%">DEALER TYPE</th>
              <th style="width: 45%">DESCRIPTION</th>
              <th style="width: 20%; text-align: right">ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in paginatedData" :key="index">
              <td>{{ item.type }}</td>
              <td>{{ item.description }}</td>
              <td style="text-align: right">
                <div class="dropdown-container">
                  <button @click="toggleDropdown(index)" class="actions-trigger">
                    ACTIONS <v-icon size="14">mdi-chevron-down</v-icon>
                  </button>
                  <div v-if="activeDropdown === index" class="actions-menu">
                    <div class="menu-opt" @click="openEditModal(item)">Edit</div>
                    <div class="menu-opt delete" @click="deleteType(item)">Delete</div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="pagination-bar">
        <div class="page-range">
          {{ paginationRange }} of {{ filteredDealerTypes.length }}
        </div>
        <div class="pagination-right">
          <span class="rows-label">Rows per page:</span>
          <select v-model="rowsPerPage" class="rows-select">
            <option :value="10">10</option>
            <option :value="20">20</option>
          </select>
          <div class="nav-arrows">
            <button :disabled="currentPage === 1" @click="currentPage--" class="arrow-btn">
              <v-icon size="18">mdi-chevron-left</v-icon>
            </button>
            <span class="current-total">{{ currentPage }}/{{ totalPages }}</span>
            <button :disabled="currentPage === totalPages" @click="currentPage++" class="arrow-btn">
              <v-icon size="18">mdi-chevron-right</v-icon>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showModal" class="modal-backdrop">
      <div class="modal-box">
        <div class="modal-top">
          <span class="modal-title">{{ isEditMode ? 'EDIT DEALER TYPE' : 'CREATE DEALER TYPE' }}</span>
          <button @click="closeModal" class="modal-close-btn">
            <v-icon size="22">mdi-close-circle-outline</v-icon>
          </button>
        </div>
        <div class="modal-middle">
          <div class="modal-input-group">
            <label>Dealer Type *</label>
            <input v-model="form.type" type="text" placeholder="Enter dealer type here" />
          </div>
          <div class="rich-editor-box">
            <label class="editor-title">Dealer Type Description</label>
            <div class="editor-tools">
              <v-icon size="18">mdi-undo</v-icon>
              <v-icon size="18">mdi-redo</v-icon>
              <span class="divider">|</span>
              <v-icon size="18">mdi-format-bold</v-icon>
              <v-icon size="18">mdi-format-italic</v-icon>
              <v-icon size="18">mdi-format-underline</v-icon>
              <v-icon size="18">mdi-format-strikethrough</v-icon>
              <span class="divider">|</span>
              <v-icon size="18">mdi-format-align-left</v-icon>
              <v-icon size="18">mdi-format-align-center</v-icon>
              <v-icon size="18">mdi-format-align-right</v-icon>
              <v-icon size="18">mdi-format-align-justify</v-icon>
              <span class="divider">|</span>
              <v-icon size="18">mdi-format-list-bulleted</v-icon>
              <v-icon size="18">mdi-format-list-numbered</v-icon>
              <v-icon size="18">mdi-link</v-icon>
            </div>
            <textarea v-model="form.description" placeholder="Type here"></textarea>
          </div>
        </div>
        <div class="modal-bottom">
          <button class="btn-create-modal" @click="handleSave">
            {{ isEditMode ? 'UPDATE' : 'CREATE' }}
          </button>
          <button class="btn-cancel-modal" @click="closeModal">CANCEL</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed } from 'vue';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';

const searchQuery = ref('');
const activeDropdown = ref(null);
const currentPage = ref(1);
const rowsPerPage = ref(10);
const showModal = ref(false);
const isEditMode = ref(false);
const editId = ref(null);

const notification = reactive({
  show: false,
  type: 'success',
  title: '',
  message: '',
  icon: 'mdi-check-circle'
});

const dealerTypes = ref([
  { id: 1, type: 'Furniture House', description: 'No' },
  { id: 2, type: 'Restaurants', description: 'No' },
  { id: 3, type: 'Hotels', description: 'No' }
]);

const form = reactive({ type: '', description: '' });

const showToast = (title, message, type = 'success') => {
  notification.title = title;
  notification.message = message;
  notification.type = type;
  notification.icon = type === 'success' ? 'mdi-check-circle' : 'mdi-alert-circle';
  notification.show = true;
  setTimeout(() => { notification.show = false; }, 3000);
};

const filteredDealerTypes = computed(() => {
  return dealerTypes.value.filter(item => 
    item.type.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
    item.description.toLowerCase().includes(searchQuery.value.toLowerCase())
  );
});

const totalPages = computed(() => Math.ceil(filteredDealerTypes.value.length / rowsPerPage.value) || 1);
const paginatedData = computed(() => {
  const start = (currentPage.value - 1) * rowsPerPage.value;
  return filteredDealerTypes.value.slice(start, start + rowsPerPage.value);
});

const paginationRange = computed(() => {
  const start = (currentPage.value - 1) * rowsPerPage.value + 1;
  const end = Math.min(currentPage.value * rowsPerPage.value, filteredDealerTypes.value.length);
  return `${start}-${String(end).padStart(2, '0')}`;
});

const toggleDropdown = (index) => {
  activeDropdown.value = activeDropdown.value === index ? null : index;
};

const goBack = () => window.history.back();

const openCreateModal = () => {
  isEditMode.value = false;
  form.type = '';
  form.description = '';
  showModal.value = true;
};

const openEditModal = (item) => {
  isEditMode.value = true;
  editId.value = item.id;
  form.type = item.type;
  form.description = item.description;
  showModal.value = true;
  activeDropdown.value = null;
};

const closeModal = () => { showModal.value = false; };

const handleSave = () => {
  if (isEditMode.value) {
    const idx = dealerTypes.value.findIndex(d => d.id === editId.value);
    dealerTypes.value[idx] = { ...dealerTypes.value[idx], ...form };
    showToast('Updated', 'Dealer type details modified.');
  } else {
    dealerTypes.value.push({ id: Date.now(), ...form });
    showToast('Success', 'New dealer type created.');
  }
  closeModal();
};

const deleteType = (item) => {
  dealerTypes.value = dealerTypes.value.filter(d => d.id !== item.id);
  activeDropdown.value = null;
  showToast('Deleted', 'Entry removed from list.', 'error');
};

const exportToPDF = () => {
  const doc = new jsPDF();
  doc.text("Dealer Type List", 14, 15);
  doc.autoTable({
    startY: 20,
    head: [['Dealer Type', 'Description']],
    body: filteredDealerTypes.value.map(i => [i.type, i.description]),
  });
  doc.save('Dealer_Types.pdf');
  showToast('Exported', 'PDF report downloaded.');
};

const exportToExcel = () => {
  const ws = XLSX.utils.json_to_sheet(filteredDealerTypes.value);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Dealer Types");
  XLSX.writeFile(wb, "Dealer_Types.xlsx");
  showToast('Exported', 'Excel file downloaded.');
};
</script>

<style scoped>
.dealer-types-container { padding: 25px; background-color: #fdfdfe; min-height: 100vh; font-family: 'Inter', sans-serif; }

.header-section { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 25px; }
.title-area h2 { font-size: 1.3rem; font-weight: 700; color: #404a5f; margin: 0; }
.title-area p { font-size: 0.85rem; color: #949eb0; margin-top: 4px; }
.btn-back { background: none; border: none; font-weight: 800; color: #404a5f; cursor: pointer; display: flex; align-items: center; gap: 5px; font-size: 0.9rem; }

.main-card { background: white; border: 1px solid #f0f2f5; border-radius: 12px; padding: 25px; box-shadow: 0 4px 6px rgba(0,0,0,0.01); }

.card-header-row { display: flex; justify-content: space-between; align-items: center; margin-bottom: 30px; }
.card-title { font-size: 0.85rem; font-weight: 700; color: #4b5563; }
.action-header-btns { display: flex; gap: 12px; }

.btn-create-outline { border: 1px solid #e2e8f0; background: white; border-radius: 8px; padding: 10px 18px; font-size: 0.75rem; font-weight: 700; color: #4b5563; cursor: pointer; transition: background 0.2s; }
.export-btn { border-radius: 6px; border: 1px solid; padding: 8px 16px; font-size: 0.8rem; font-weight: 600; cursor: pointer; display: flex; align-items: center; }
.export-btn.pdf { border-color: #3b82f6; background-color: #eff6ff; color: #1e40af; }
.export-btn.excel { border-color: #a855f7; background-color: #f5f3ff; color: #6b21a8; }

.search-stats-container { display: flex; gap: 20px; margin-bottom: 25px; }
.stats-box { border: 1px solid #e2e8f0; border-radius: 10px; width: 140px; padding: 12px; text-align: center; }
.stats-number { font-size: 1.5rem; font-weight: 800; color: #3b82f6; line-height: 1; }
.stats-text { font-size: 0.6rem; font-weight: 700; color: #94a3b8; margin-top: 6px; }

.search-box-wrapper { flex-grow: 1; }
.search-fieldset { border: 1px solid #cbd5e1; border-radius: 8px; padding: 0 15px 10px; position: relative; }
.search-fieldset label { position: absolute; top: -10px; left: 15px; background: white; padding: 0 5px; font-size: 0.75rem; font-weight: 600; color: #64748b; }
.search-fieldset input { width: 100%; border: none; outline: none; margin-top: 10px; font-size: 0.9rem; color: #1e293b; }

.dealer-table { width: 100%; border-collapse: collapse; margin-top: 10px; }
.dealer-table th { text-align: left; padding: 16px; font-size: 0.75rem; color: #475569; border-bottom: 1px solid #f1f3f7; font-weight: 700; }
.dealer-table td { padding: 16px; font-size: 0.85rem; color: #334155; border-bottom: 1px solid #f8fafc; }

.actions-trigger { background-color: #f3e8ff; color: #9333ea; border: none; padding: 8px 18px; border-radius: 8px; font-weight: 700; font-size: 0.75rem; cursor: pointer; display: inline-flex; align-items: center; gap: 8px; }
.dropdown-container { position: relative; }
.actions-menu { position: absolute; right: 0; top: 110%; background: white; border: 1px solid #f0f2f5; border-radius: 8px; box-shadow: 0 8px 16px rgba(0,0,0,0.08); z-index: 50; min-width: 130px; padding: 5px 0; }
.menu-opt { padding: 10px 15px; font-size: 0.85rem; color: #334155; cursor: pointer; }
.menu-opt:hover { background: #f8fafc; }
.menu-opt.delete { color: #ef4444; }

.pagination-bar { display: flex; justify-content: space-between; align-items: center; padding-top: 25px; margin-top: 15px; border-top: 1px solid #f1f3f7; }
.page-range { font-size: 0.85rem; font-weight: 600; color: #64748b; }
.pagination-right { display: flex; align-items: center; gap: 20px; }
.rows-label { font-size: 0.75rem; color: #64748b; }
.rows-select { border: none; font-weight: 700; color: #1e293b; cursor: pointer; outline: none; }
.nav-arrows { display: flex; align-items: center; border: 1px solid #e2e8f0; border-radius: 6px; padding: 3px 10px; gap: 12px; }
.arrow-btn { background: none; border: none; cursor: pointer; color: #94a3b8; padding: 0; display: flex; align-items: center; }
.current-total { font-size: 0.8rem; font-weight: 700; color: #1e293b; }

.modal-backdrop { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.4); display: flex; justify-content: center; align-items: center; z-index: 500; }
.modal-box { background: white; border-radius: 12px; width: 550px; box-shadow: 0 20px 40px rgba(0,0,0,0.15); }
.modal-top { padding: 18px 25px; border-bottom: 1px solid #f3f4f6; display: flex; justify-content: space-between; align-items: center; }
.modal-title { font-size: 0.8rem; font-weight: 800; color: #4b5563; }
.modal-close-btn { background: none; border: none; color: #94a3b8; cursor: pointer; display: flex; }

.modal-middle { padding: 25px; }
.modal-input-group { border: 1px solid #cbd5e1; border-radius: 8px; padding: 0 15px 12px; position: relative; margin-bottom: 25px; }
.modal-input-group label { position: absolute; top: -10px; left: 15px; background: white; padding: 0 5px; font-size: 0.7rem; font-weight: 600; color: #64748b; }
.modal-input-group input { width: 100%; border: none; outline: none; margin-top: 12px; font-size: 0.9rem; }

.rich-editor-box { border: 1px solid #cbd5e1; border-radius: 8px; padding: 15px; }
.editor-title { font-size: 0.8rem; font-weight: 700; color: #4b5563; margin-bottom: 12px; display: block; }
.editor-tools { display: flex; gap: 12px; border-bottom: 1px solid #f3f4f6; padding-bottom: 12px; margin-bottom: 15px; color: #64748b; }
.divider { color: #e5e7eb; }
.rich-editor-box textarea { width: 100%; height: 120px; border: none; outline: none; font-size: 0.9rem; resize: none; color: #334155; }

.modal-bottom { padding: 10px 25px 30px; display: flex; gap: 12px; justify-content: center; }
.btn-create-modal { background-color: #f3e8ff; color: #9333ea; border: none; padding: 12px 35px; border-radius: 8px; font-weight: 800; font-size: 0.8rem; cursor: pointer; }
.btn-cancel-modal { border: 1px solid #e5e7eb; background: white; padding: 12px 35px; border-radius: 8px; font-weight: 800; color: #4b5563; cursor: pointer; font-size: 0.8rem; }

.toast-notification { position: fixed; top: 25px; right: 25px; min-width: 320px; padding: 16px; border-radius: 10px; display: flex; align-items: center; gap: 15px; z-index: 2000; box-shadow: 0 12px 24px rgba(0,0,0,0.12); }
.toast-notification.success { background: #10b981; color: white; }
.toast-notification.error { background: #ef4444; color: white; }
.toast-content { display: flex; flex-direction: column; }
.toast-title { font-weight: 800; font-size: 0.9rem; }
.toast-msg { font-size: 0.8rem; opacity: 0.9; }

.toast-enter-active, .toast-leave-active { transition: transform 0.4s ease, opacity 0.4s; }
.toast-enter-from, .toast-leave-to { transform: translateX(50px); opacity: 0; }
</style> -->





<template>
  <div class="dealer-types-container">
    <transition name="toast">
      <div v-if="notification.show" class="toast-notification" :class="notification.type">
        <v-icon size="20" color="white">{{ notification.icon }}</v-icon>
        <div class="toast-content">
          <span class="toast-title">{{ notification.title }}</span>
          <span class="toast-msg">{{ notification.message }}</span>
        </div>
      </div>
    </transition>

    <div class="header-section">
      <div class="title-area">
        <h2>CREATE & VIEW DEALER TYPES</h2>
        <p>Establish & access a new dealer types tailored to your needs.</p>
      </div>
      <!-- <button class="btn-back" @click="goBack">
        <v-icon size="18" color="#404a5f">mdi-chevron-left</v-icon> BACK
      </button> -->
      <button class="btn-back" @click="goBack">
        <span class="back-arrow">◀</span> BACK
      </button>
    </div>

    <div class="main-card">
      <div class="card-header-row">
        <div class="action-header-btns">
          <button class="btn-create-solid" @click="openCreateModal">CREATE NEW DEALER TYPE</button>
          <button class="export-btn pdf" @click="exportToPDF">
            <v-icon size="18" color="white" class="mr-1">mdi-file-pdf-box</v-icon> PDF
          </button>
          <button class="export-btn excel" @click="exportToExcel">
            <v-icon size="18" color="white" class="mr-1">mdi-file-excel-box</v-icon> EXCEL
          </button>
        </div>
      </div>

      <div class="filter-header-bar">
        <div class="filter-title">
          <v-icon size="20" class="mr-2">mdi-filter-variant</v-icon>
          FILTERS
        </div>
        <v-icon size="20">mdi-chevron-up</v-icon>
      </div>

      <div class="search-stats-container">
        <div class="stats-box">
          <div class="stats-number">{{ filteredDealerTypes.length }}</div>
          <div class="stats-text">NUMBER OF TYPES</div>
        </div>
        <div class="search-box-wrapper">
          <div class="outlined-group">
            <label>Search</label>
            <div class="input-wrapper">
              <input v-model="searchQuery" type="text" placeholder="Search by type or description" />
              <v-icon class="search-icon">mdi-magnify</v-icon>
            </div>
          </div>
        </div>
      </div>

      <div class="table-container">
        <table class="dealer-table">
          <thead>
            <tr>
              <th style="width: 35%">DEALER TYPE</th>
              <th style="width: 45%">DESCRIPTION</th>
              <th style="width: 20%; text-align: right">ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in paginatedData" :key="index">
              <td class="type-cell">{{ item.type }}</td>
              <td class="desc-cell">{{ item.description }}</td>
              <td style="text-align: right">
                <!-- <div class="actions-dropdown-container">
                  <button @click="toggleDropdown(index)" class="btn-actions-trigger">
                    ACTIONS <v-icon size="14">mdi-chevron-down</v-icon>
                  </button>
                  <div v-if="activeDropdown === index" class="dropdown-list-menu">
                    <div class="list-item" @click="openEditModal(item)">Edit</div>
                    <div class="list-item text-danger" @click="deleteType(item)">Delete</div>
                  </div>
                </div> -->
                <div class="actions-dropdown-container">
                  <button @click="toggleDropdown(index)" class="btn-actions-trigger">
                    ACTIONS <v-icon size="14">mdi-chevron-down</v-icon>
                  </button>
                  
                  <div v-if="activeDropdown === index" class="dropdown-list-menu">
                    <div class="list-item edit-btn" @click="openEditModal(item)">EDIT</div>
                    <div class="list-item delete-btn" @click="deleteType(item)">DELETE</div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="pagination-bar">
        <div class="page-range">
          {{ paginationRange }} of {{ filteredDealerTypes.length }}
        </div>
        <div class="pagination-right">
          <span class="rows-label">Rows per page:</span>
          <select v-model="rowsPerPage" class="rows-select">
            <option :value="10">10</option>
            <option :value="20">20</option>
          </select>
          <div class="nav-arrows">
            <button :disabled="currentPage === 1" @click="currentPage--" class="arrow-btn">
              <v-icon size="18">mdi-chevron-left</v-icon>
            </button>
            <span class="current-total">{{ currentPage }}/{{ totalPages }}</span>
            <button :disabled="currentPage === totalPages" @click="currentPage++" class="arrow-btn">
              <v-icon size="18">mdi-chevron-right</v-icon>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showModal" class="modal-backdrop">
      <div class="modal-box">
        <div class="modal-top">
          <span class="modal-title">{{ isEditMode ? 'EDIT DEALER TYPE' : 'CREATE DEALER TYPE' }}</span>
          <button @click="closeModal" class="modal-close-btn">
            <v-icon size="22">mdi-close-circle-outline</v-icon>
          </button>
        </div>
        <div class="modal-middle">
          <div class="outlined-group mb-6">
            <label>Dealer Type *</label>
            <input v-model="form.type" type="text" placeholder="Enter dealer type here" />
          </div>
          <div class="rich-editor-box">
            <label class="editor-title">Dealer Type Description</label>
            <div class="editor-tools">
              <v-icon size="18">mdi-undo</v-icon>
              <v-icon size="18">mdi-redo</v-icon>
              <span class="divider">|</span>
              <v-icon size="18">mdi-format-bold</v-icon>
              <v-icon size="18">mdi-format-italic</v-icon>
              <v-icon size="18">mdi-format-underline</v-icon>
              <span class="divider">|</span>
              <v-icon size="18">mdi-format-align-left</v-icon>
              <v-icon size="18">mdi-format-align-center</v-icon>
              <v-icon size="18">mdi-format-list-bulleted</v-icon>
            </div>
            <textarea v-model="form.description" placeholder="Type here"></textarea>
          </div>
        </div>
        <div class="modal-bottom">
          <button class="btn-save-modal" @click="handleSave">
            {{ isEditMode ? 'UPDATE' : 'CREATE' }}
          </button>
          <button class="btn-cancel-modal" @click="closeModal">CANCEL</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed } from 'vue';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';

const searchQuery = ref('');
const activeDropdown = ref(null);
const currentPage = ref(1);
const rowsPerPage = ref(10);
const showModal = ref(false);
const isEditMode = ref(false);
const editId = ref(null);

const notification = reactive({
  show: false,
  type: 'success',
  title: '',
  message: '',
  icon: 'mdi-check-circle'
});

const dealerTypes = ref([
  { id: 1, type: 'Furniture House', description: 'Dealers specialized in home and office furniture' },
  { id: 2, type: 'Restaurants', description: 'Commercial food and beverage establishments' },
  { id: 3, type: 'Hotels', description: 'Hospitality and lodging service providers' }
]);

const form = reactive({ type: '', description: '' });

const showToast = (title, message, type = 'success') => {
  notification.title = title;
  notification.message = message;
  notification.type = type;
  notification.icon = type === 'success' ? 'mdi-check-circle' : 'mdi-alert-circle';
  notification.show = true;
  setTimeout(() => { notification.show = false; }, 3000);
};

const filteredDealerTypes = computed(() => {
  return dealerTypes.value.filter(item => 
    item.type.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
    item.description.toLowerCase().includes(searchQuery.value.toLowerCase())
  );
});

const totalPages = computed(() => Math.ceil(filteredDealerTypes.value.length / rowsPerPage.value) || 1);
const paginatedData = computed(() => {
  const start = (currentPage.value - 1) * rowsPerPage.value;
  return filteredDealerTypes.value.slice(start, start + rowsPerPage.value);
});

const paginationRange = computed(() => {
  const start = (currentPage.value - 1) * rowsPerPage.value + 1;
  const end = Math.min(currentPage.value * rowsPerPage.value, filteredDealerTypes.value.length);
  return `${start}-${String(end).padStart(2, '0')}`;
});

const toggleDropdown = (index) => {
  activeDropdown.value = activeDropdown.value === index ? null : index;
};

const goBack = () => window.history.back();

const openCreateModal = () => {
  isEditMode.value = false;
  form.type = '';
  form.description = '';
  showModal.value = true;
};

const openEditModal = (item) => {
  isEditMode.value = true;
  editId.value = item.id;
  form.type = item.type;
  form.description = item.description;
  showModal.value = true;
  activeDropdown.value = null;
};

const closeModal = () => { showModal.value = false; };

const handleSave = () => {
  if (isEditMode.value) {
    const idx = dealerTypes.value.findIndex(d => d.id === editId.value);
    dealerTypes.value[idx] = { ...dealerTypes.value[idx], ...form };
    showToast('Updated', 'Dealer type details modified.');
  } else {
    dealerTypes.value.push({ id: Date.now(), ...form });
    showToast('Success', 'New dealer type created.');
  }
  closeModal();
};

const deleteType = (item) => {
  dealerTypes.value = dealerTypes.value.filter(d => d.id !== item.id);
  activeDropdown.value = null;
  showToast('Deleted', 'Entry removed from list.', 'error');
};

const exportToPDF = () => {
  const doc = new jsPDF();
  doc.text("Dealer Type List", 14, 15);
  doc.autoTable({
    startY: 20,
    head: [['Dealer Type', 'Description']],
    body: filteredDealerTypes.value.map(i => [i.type, i.description]),
  });
  doc.save('Dealer_Types.pdf');
  showToast('Exported', 'PDF report downloaded.');
};

const exportToExcel = () => {
  const ws = XLSX.utils.json_to_sheet(filteredDealerTypes.value);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Dealer Types");
  XLSX.writeFile(wb, "Dealer_Types.xlsx");
  showToast('Exported', 'Excel file downloaded.');
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Public+Sans:wght@400;500;600;700;800&display=swap');

.dealer-types-container {
  padding: 25px;
  background-color: #fdfdfe;
  min-height: 100vh;
  font-family: 'Public Sans', sans-serif;
}

.header-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
}

.title-area h2 {
  font-size: 1.4rem;
  font-weight: 800;
  color: #455a64;
  margin: 0;
  text-transform: uppercase;
}

.title-area p {
  font-size: 0.85rem;
  color: #90a4ae;
  margin-top: 4px;
}

.btn-back {
  background: rgba(255, 255, 255, 0);
  /* border: 1px solid #e2e8f0;
  border-radius: 6px; */
  font-weight: 700;
  color: #2d3748;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.2rem;
  padding: 8px 16px;
}

.main-card {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  padding: 25px;
}

.card-header-row {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.action-header-btns {
  display: flex;
  gap: 12px;
}

.btn-create-solid { border: 1px solid #e2e8f000; background: rgba(255, 255, 255, 0); border-radius: 4px; padding: 8px 16px; font-size: 1.0rem; font-weight: 700; color: #4b5563; cursor: pointer; }

.export-btn { border: none; border-radius: 4px; padding: 8px 22px; color: white; font-weight: bold; font-size: 0.8rem; display: flex; align-items: center; cursor: pointer; }
.export-btn.pdf { background-color: #0b4a99; }
.export-btn.excel { background-color: #004d3d; }

.filter-header-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f1f5f9;
  margin-bottom: 25px;
}

.filter-title {
  display: flex;
  align-items: center;
  font-weight: 800;
  font-size: 0.9rem;
  color: #37474f;
}

.search-stats-container {
  display: flex;
  gap: 20px;
  margin-bottom: 30px;
}

.stats-box {
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  width: 150px;
  padding: 15px;
  text-align: center;
}

.stats-number {
  font-size: 1.8rem;
  font-weight: 800;
  color: #8E44AD;
  line-height: 1;
}

.stats-text {
  font-size: 0.65rem;
  font-weight: 800;
  color: #94a3b8;
  margin-top: 8px;
  text-transform: uppercase;
}

.search-box-wrapper { flex-grow: 1; }

.outlined-group {
  position: relative;
  border: 1px solid #cbd5e0;
  border-radius: 4px;
  padding: 0 15px;
  height: 52px;
  display: flex;
  align-items: center;
  background: white;
}

.outlined-group label {
  position: absolute;
  top: -10px;
  left: 12px;
  background: white;
  padding: 0 5px;
  font-size: 0.75rem;
  font-weight: 700;
  color: #455a64;
}

.input-wrapper {
  width: 100%;
  display: flex;
  align-items: center;
}

.outlined-group input {
  width: 100%;
  border: none;
  outline: none;
  font-size: 0.9rem;
  color: #455a64;
}

.search-icon { color: #90a4ae; }

.dealer-table {
  width: 100%;
  border-collapse: collapse;
}

.dealer-table th {
  text-align: left;
  padding: 18px 20px;
  font-size: 0.75rem;
  color: #37474f;
  border-bottom: 2px solid #edf2f7;
  font-weight: 800;
  text-transform: uppercase;
}

.dealer-table td {
  padding: 18px 20px;
  font-size: 0.85rem;
  color: #455a64;
  border-bottom: 1px solid #edf2f7;
}

.type-cell { font-weight: 700; color: #2d3748; }
.desc-cell { color: #718096; }

.btn-actions-trigger {
  background: #8E44AD;
  color: #ffffff;
  border: 1px solid #e2e8f0;
  padding: 8px 16px;
  border-radius: 4px;
  font-weight: 700;
  font-size: 0.75rem;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-width: 110px;
  justify-content: space-between;
}

/* Container for positioning */
.actions-dropdown-container {
  position: relative;
  display: inline-block;
}

/* The white box (dropdown) */
.dropdown-list-menu {
  position: absolute;
  right: 0;
  top: calc(100% + 5px);
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  z-index: 50;
  min-width: 140px;
  padding: 8px 0;
  display: flex;
  flex-direction: column;
}

/* Individual items */
.list-item {
  padding: 12px 20px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
  text-align: left; /* Aligned to the left */
  width: 100%;
  transition: background 0.2s ease;
}

/* Hover state */
.list-item:hover {
  background-color: #f8fafc;
}

/* Colors matching your image */
.edit-btn {
  color: #448b44; /* Greenish */
}

.delete-btn {
  color: #b91c1c; /* Red */
}
.list-item:hover { background: #f7fafc; }
.text-danger { color: #e53e3e !important; }

.pagination-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 25px;
  margin-top: 15px;
  border-top: 1px solid #edf2f7;
}

.page-range { font-size: 0.85rem; font-weight: 700; color: #64748b; }
.pagination-right { display: flex; align-items: center; gap: 20px; }
.rows-label { font-size: 0.75rem; color: #64748b; font-weight: 600; }
.rows-select { border: none; font-weight: 800; color: #1e293b; outline: none; background: transparent; cursor: pointer; }

.nav-arrows {
  display: flex;
  align-items: center;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  padding: 4px 12px;
  gap: 15px;
}

.arrow-btn { background: none; border: none; cursor: pointer; color: #94a3b8; display: flex; align-items: center; }
.current-total { font-size: 0.8rem; font-weight: 800; color: #1e293b; }

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 500;
}

.modal-box {
  background: white;
  border-radius: 4px;
  width: 580px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
}

.modal-top {
  padding: 20px 25px;
  border-bottom: 1px solid #f1f5f9;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-title { font-size: 0.9rem; font-weight: 800; color: #37474f; }
.modal-close-btn { background: none; border: none; color: #94a3b8; cursor: pointer; }

.modal-middle { padding: 30px 25px; }

.rich-editor-box {
  border: 1px solid #cbd5e0;
  border-radius: 4px;
  padding: 15px;
}

.editor-title { font-size: 0.8rem; font-weight: 700; color: #455a64; margin-bottom: 12px; display: block; }
.editor-tools { display: flex; gap: 12px; border-bottom: 1px solid #f1f5f9; padding-bottom: 12px; margin-bottom: 15px; color: #90a4ae; }
.divider { color: #e2e8f0; }

.rich-editor-box textarea {
  width: 100%;
  height: 140px;
  border: none;
  outline: none;
  font-size: 0.9rem;
  resize: none;
  color: #455a64;
}

.modal-bottom {
  padding: 0 25px 35px;
  display: flex;
  gap: 15px;
  justify-content: center;
}

.btn-save-modal {
  background-color: #8E44AD;
  color: #ffffff;
  border: none;
  padding: 12px 45px;
  border-radius: 4px;
  font-weight: 800;
  font-size: 0.8rem;
  cursor: pointer;
}

.btn-cancel-modal {
  border: 1px solid #e2e8f0;
  background: white;
  padding: 12px 45px;
  border-radius: 4px;
  font-weight: 800;
  color: #455a64;
  cursor: pointer;
  font-size: 0.8rem;
}

.toast-notification {
  position: fixed;
  top: 25px;
  right: 25px;
  min-width: 340px;
  padding: 18px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 15px;
  z-index: 2000;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
}

.toast-notification.success { background: #2e7d32; color: white; }
.toast-notification.error { background: #c62828; color: white; }
.toast-title { font-weight: 800; font-size: 0.95rem; display: block; }
.toast-msg { font-size: 0.85rem; opacity: 0.9; }

.mb-6 { margin-bottom: 24px; }

.toast-enter-active, .toast-leave-active { transition: all 0.4s ease; }
.toast-enter-from { transform: translateX(100%); opacity: 0; }
.toast-leave-to { opacity: 0; }
</style>